import styled from '@emotion/styled'

const hexaStyle = `
  right: 80px; 
  top: 35px; 

  @media (max-width: 768px) {
    top: 30px; 
    left: -50%;
    :after {
      left: 70%;
    }
  }
`

export const arrowTop = `
  :after {
    content: ' ';
    position: absolute;
    right: 14px;
    top: -8px;
    border-top: none;
    border-right: 5px solid transparent;
    border-left: 5px solid transparent;
    border-bottom: 8px solid #fff0b6;

    @media (max-width: 768px) {
      left: 50%;
      right: initial;
      transform: translateX(-50%);
    }
  }
`

export const BoxWrapper = styled.div(
  ({ isHexaHeader }) => ` 
  height: 28px;
  background-color: #fff0b6;
  color: #fd8e43;
  position: absolute;
  margin-top: 5px;
  border-radius: 6px;
  right: 40px;
  top: 45px;
  width: max-content;
  padding: 0px 10px 0px 10px;
  display: flex;
  align-items: center;
  font-size: 13px;
  box-shadow: 0px 3px 8px #c7c7c7;

  @media (max-width: 768px) {
    top: 100px;
    left: 50%;
    right: initial;
    transform: translateX(-50%);
  }

  ${arrowTop}
  ${isHexaHeader && hexaStyle}
`
)
